export default __webpack_public_path__ + "static/media/header-XC60.7efe0edc.jpg";